import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import Keycloak from 'keycloak-js';
import { environment } from '../../../environments/environment';

const apiBaseUrl = environment.apiUrl.endsWith('/') ? environment.apiUrl : `${environment.apiUrl}/`;

export const authInterceptor: HttpInterceptorFn = (request, next) => {
  const keycloak = inject(Keycloak);
  const isApiRequest = request.url.startsWith(apiBaseUrl);

  if (!isApiRequest || !keycloak.authenticated || !keycloak.token) {
    return next(request);
  }

  return next(
    request.clone({
      setHeaders: {
        Authorization: `Bearer ${keycloak.token}`,
      },
    }),
  );
};